import React, { useEffect, useState } from "react";
import {
  Card,
  Row,
  Col,
  Badge,
  Carousel,
  Button,
} from "react-bootstrap";
import { useParams } from "react-router-dom";
import axios from "axios";
import PageLayout from "../../../layouts/PageLayout";

export default function ViewTraining() {
  const { id } = useParams();

  const [training, setTraining] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const AuthToken = localStorage.getItem("AuthUser");

  useEffect(() => {
    fetchTraining();
  }, [id]);

  const fetchTraining = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/vocational-training/${id}`,
        {
          headers: {
            Authorization: `Bearer ${AuthToken}`,
          },
        }
      );

      setTraining(res.data.data);
    } catch (error) {
      console.error("Error fetching training:", error);
    }
  };

  const getFileUrl = (path) => {
    if (!path) return "";

    const baseUrl = process.env.REACT_APP_IMG_URL || "";

    return `${baseUrl}/${path}`.replace(
      /([^:]\/)\/+/g,
      "$1"
    );
  };

  const formatCurrency = (amount) => {
    return `Rs. ${Number(amount || 0).toLocaleString()}`;
  };

  const formatDate = (date) => {
    if (!date) return "-";

    return new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  if (!training) {
    return (
      <PageLayout>
        <Card className="border-0 shadow-sm">
          <Card.Body className="text-center py-5">
            Loading training details...
          </Card.Body>
        </Card>
      </PageLayout>
    );
  }

  const fee = Number(training.fee || 0);
  const hostel = Number(training.hostel_expenses || 0);
  const uniform = Number(training.uniform_expenses || 0);
  const other = Number(training.other_expenses || 0);

  const totalExpenses =
    hostel + uniform + other;

  const grandTotal =
    fee + totalExpenses;

  const expenseData = [
    {
      title: "Training Fee",
      amount: fee,
      file: training.fee_receipt,
      button: "View Receipt",
    },
    {
      title: "Hostel Expenses",
      amount: hostel,
      file: training.hostel_expense_file,
      button: "View File",
    },
    {
      title: "Uniform Expenses",
      amount: uniform,
      file: training.uniform_expense_file,
      button: "View File",
    },
    {
      title: "Other Expenses",
      amount: other,
      file: training.other_expense_file,
      button: "View File",
    },
  ];

  return (
    <PageLayout>

      {/* =============================
          MAIN PROFILE HEADER
      ============================== */}

      <Card className="border-0 shadow-sm mb-4">
        <Card.Body className="p-4">

          <Row className="align-items-center">

            <Col md={8}>
              <div className="d-flex align-items-center">

                <div
                  className="rounded-circle d-flex align-items-center justify-content-center me-3"
                  style={{
                    width: "60px",
                    height: "60px",
                    background: "#f1f5f9",
                    fontSize: "24px",
                    fontWeight: "bold",
                  }}
                >
                  {training.student_name
                    ?.charAt(0)
                    ?.toUpperCase()}
                </div>

                <div>
                  <h4 className="mb-1">
                    {training.student_name || "Student"}
                  </h4>

                  <div className="text-muted">

                    {training.course?.course_name || "Training"}

                    <span className="mx-2">
                      •
                    </span>

                    {training.institute?.name || "-"}

                  </div>

                  <small className="text-muted">
                    Family: {training.family?.f_number || "-"}
                  </small>
                </div>

              </div>
            </Col>

            <Col
              md={4}
              className="text-md-end mt-3 mt-md-0"
            >
              <Badge
                bg="success"
                className="px-3 py-2"
                style={{
                  fontSize: "14px",
                }}
              >
                {training.progress || "N/A"}
              </Badge>
            </Col>

          </Row>

        </Card.Body>
      </Card>


      {/* =============================
          FINANCIAL SUMMARY
      ============================== */}

      <Row className="mb-4">

        <Col md={4} className="mb-3">
          <Card className="border-0 shadow-sm h-100">
            <Card.Body>

              <small className="text-muted">
                Training Fee
              </small>

              <h3 className="mt-2 mb-0">
                {formatCurrency(fee)}
              </h3>

            </Card.Body>
          </Card>
        </Col>

        <Col md={4} className="mb-3">
          <Card className="border-0 shadow-sm h-100">
            <Card.Body>

              <small className="text-muted">
                Additional Expenses
              </small>

              <h3 className="mt-2 mb-0">
                {formatCurrency(totalExpenses)}
              </h3>

            </Card.Body>
          </Card>
        </Col>

        <Col md={4} className="mb-3">
          <Card className="border-0 shadow-sm h-100">
            <Card.Body>

              <small className="text-muted">
                Total Amount
              </small>

              <h3 className="mt-2 mb-0">
                {formatCurrency(grandTotal)}
              </h3>

            </Card.Body>
          </Card>
        </Col>

      </Row>


      <Row>

        {/* =============================
            TRAINING INFORMATION
        ============================== */}

        <Col lg={7} className="mb-4">

          <Card className="border-0 shadow-sm h-100">

            <Card.Header className="bg-success border-bottom py-3">
              <h5 className="mb-0 text-light">
                Training Information
              </h5>
            </Card.Header>

            <Card.Body className="p-0">

              <div className="table-responsive">

                <table className="table table-hover mb-0">

                  <tbody>

                    <tr>
                      <td className="text-muted ps-4">
                        Student Name
                      </td>

                      <td className="text-end pe-4">
                        <strong>
                          {training.student_name || "-"}
                        </strong>
                      </td>
                    </tr>

                    <tr>
                      <td className="text-muted ps-4">
                        Family Number
                      </td>

                      <td className="text-end pe-4">
                        {training.family?.f_number || "-"}
                      </td>
                    </tr>

                    <tr>
                      <td className="text-muted ps-4">
                        Relation
                      </td>

                      <td className="text-end pe-4">
                        {training.relation || "-"}
                      </td>
                    </tr>

                    <tr>
                      <td className="text-muted ps-4">
                        Institute
                      </td>

                      <td className="text-end pe-4">
                        {training.institute?.name || "-"}
                      </td>
                    </tr>

                    <tr>
                      <td className="text-muted ps-4">
                        Course
                      </td>

                      <td className="text-end pe-4">
                        {training.course?.course_name || "-"}
                      </td>
                    </tr>

                    <tr>
                      <td className="text-muted ps-4">
                        Duration
                      </td>

                      <td className="text-end pe-4">
                        {training.duration || "-"}
                      </td>
                    </tr>

                    <tr>
                      <td className="text-muted ps-4">
                        Start Date
                      </td>

                      <td className="text-end pe-4">
                        {formatDate(training.start_date)}
                      </td>
                    </tr>

                    <tr>
                      <td className="text-muted ps-4">
                        End Date
                      </td>

                      <td className="text-end pe-4">
                        {training.end_date
                          ? formatDate(training.end_date)
                          : "Ongoing"}
                      </td>
                    </tr>

                  </tbody>

                </table>

              </div>

            </Card.Body>

          </Card>

        </Col>


        {/* =============================
            FINANCIAL BREAKDOWN
        ============================== */}

        <Col lg={5} className="mb-4">

          <Card className="border-0 shadow-sm h-100">

            <Card.Header className="bg-success border-bottom py-3">
              <h5 className="mb-0 text-light">
                Financial Breakdown
              </h5>
            </Card.Header>

            <Card.Body className="p-0">

              <div className="table-responsive">

                <table className="table mb-0">

                  <tbody>

                    {expenseData.map(
                      (expense) => (

                        <tr
                          key={expense.title}
                        >

                          <td className="ps-4">

                            <div>
                              <strong>
                                {expense.title}
                              </strong>
                            </div>

                            {expense.file && (
                              <a
                                href={getFileUrl(
                                  expense.file
                                )}
                                target="_blank"
                                rel="noreferrer"
                                className="small text-primary"
                              >
                                {expense.button}
                              </a>
                            )}

                          </td>

                          <td className="text-end pe-4">
                            {formatCurrency(
                              expense.amount
                            )}
                          </td>

                        </tr>

                      )
                    )}

                    <tr className="table-light">

                      <td className="ps-4">
                        <strong>
                          Total Additional Expenses
                        </strong>
                      </td>

                      <td className="text-end pe-4">
                        <strong>
                          {formatCurrency(
                            totalExpenses
                          )}
                        </strong>
                      </td>

                    </tr>

                    <tr>

                      <td className="ps-4">
                        <h5 className="mb-0">
                          Grand Total
                        </h5>
                      </td>

                      <td className="text-end pe-4">
                        <h5 className="mb-0">
                          {formatCurrency(
                            grandTotal
                          )}
                        </h5>
                      </td>

                    </tr>

                  </tbody>

                </table>

              </div>

            </Card.Body>

          </Card>

        </Col>

      </Row>


      {/* =============================
          STORY
      ============================== */}

      {training.story && (

        <Card className="border-0 shadow-sm mb-4">

          <Card.Header className="bg-success py-3">
            <h5 className="mb-0 text-light">
              Student Story
            </h5>
          </Card.Header>

          <Card.Body>

            <div
              style={{
                lineHeight: "1.8",
                whiteSpace: "pre-line",
              }}
            >
              {training.story}
            </div>

          </Card.Body>

        </Card>

      )}


      {/* =============================
          BEFORE / AFTER
      ============================== */}

      {(training.before_image ||
        training.after_image) && (

        <Card className="border-0 shadow-sm mb-4">

          <Card.Header className="bg-success py-3">
            <h5 className="mb-0 text-light">
              Training Progress
            </h5>
          </Card.Header>

          <Card.Body>

            <Row>

              {training.before_image && (

                <Col md={6} className="mb-3">

                  <div className="text-center mb-2">
                    <strong>
                      Before Training
                    </strong>
                  </div>

                  <img
                    src={getFileUrl(
                      training.before_image
                    )}
                    alt="Before Training"
                    className="img-fluid rounded border w-100"
                    style={{
                      height: "420px",
                      objectFit: "contain",
                    }}
                  />

                </Col>

              )}

              {training.after_image && (

                <Col md={6} className="mb-3">

                  <div className="text-center mb-2">
                    <strong>
                      After Training
                    </strong>
                  </div>

                  <img
                    src={getFileUrl(
                      training.after_image
                    )}
                    alt="After Training"
                    className="img-fluid rounded border w-100"
                    style={{
                      height: "420px",
                      objectFit: "contain",
                    }}
                  />

                </Col>

              )}

            </Row>

          </Card.Body>

        </Card>

      )}


      {/* =============================
          GALLERY
      ============================== */}

      {training.gallery?.length > 0 && (

        <Card className="border-0 shadow-sm mb-4">

          <Card.Header className="bg-white py-3">
            <h5 className="mb-0">
              Training Gallery
            </h5>
          </Card.Header>

          <Card.Body>

            <Carousel
              activeIndex={activeIndex}
              onSelect={(index) =>
                setActiveIndex(index)
              }
              interval={null}
            >

              {training.gallery.map(
                (item) => (

                  <Carousel.Item
                    key={item.id}
                  >

                    <img
                      src={getFileUrl(
                        item.img
                      )}
                      className="d-block w-100"
                      style={{
                        height: "500px",
                        objectFit: "contain",
                      }}
                      alt="Gallery"
                    />

                  </Carousel.Item>

                )
              )}

            </Carousel>

          </Card.Body>

        </Card>

      )}


      {/* =============================
          VIDEO
      ============================== */}

      {training.video && (

        <Card className="border-0 shadow-sm mb-4">

          <Card.Header className="bg-white py-3">
            <h5 className="mb-0">
              Training Video
            </h5>
          </Card.Header>

          <Card.Body>

            <video
              controls
              className="w-100 rounded"
              style={{
                maxHeight: "600px",
                background: "#000",
              }}
            >

              <source
                src={getFileUrl(
                  training.video
                )}
                type="video/mp4"
              />

            </video>

          </Card.Body>

        </Card>

      )}

    </PageLayout>
  );
}
